'use client';

import { useEffect, useState } from 'react';

import { TrackedButton } from '@/components';

import styles from './ResendButton.module.css';

interface ResendButtonProps {
  onClick: () => void;
  disabled?: boolean;
  cooldownSeconds?: number;
}

const ResendButton = ({
  onClick,
  disabled = false,
  cooldownSeconds = 30,
}: ResendButtonProps) => {
  const [countdown, setCountdown] = useState(0);

  // Start countdown on first render
  useEffect(() => {
    let timerId: NodeJS.Timeout;

    if (countdown > 0) {
      timerId = setInterval(() => {
        setCountdown((c) => Math.max(0, c - 1));
      }, 1000);
    }

    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, [countdown]);

  const handleClick = () => {
    onClick();
    // Start countdown
    setCountdown(cooldownSeconds);
  };

  return (
    <TrackedButton
      variant="subtle"
      onClick={handleClick}
      disabled={disabled || countdown > 0}
      className={styles.resendButton}
      trackingName="ResendButton_resend_code"
    >
      {countdown > 0 ? `Resend Code (${countdown}s)` : 'Resend Code'}
    </TrackedButton>
  );
};

export { ResendButton };
